var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5025 49.9999C20.4011 49.9999 26 46.2666 26 41.6666V33.3333H13.5025C6.60389 33.3333 1.005 37.0666 1.005 41.6666C1.005 46.2666 6.60389 49.9999 13.5025 49.9999Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.005 25.0001C1.005 20.4001 6.60389 16.6667 13.5025 16.6667H26V33.3334H13.5025C6.60389 33.3334 1.005 29.6001 1.005 25.0001Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.005 8.33332C1.005 3.73333 6.60389 0 13.5025 0H26V16.6666H13.5025C6.60389 16.6666 1.005 12.9333 1.005 8.33332Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 0H38.4975C45.3962 0 50.9951 3.73333 50.9951 8.33332C50.9951 12.9333 45.3962 16.6666 38.4975 16.6666H26V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9951 25.0001C50.9951 29.6001 45.3962 33.3334 38.4975 33.3334C31.5989 33.3334 26 29.6001 26 25.0001C26 20.4001 31.5989 16.6667 38.4975 16.6667C45.3962 16.6667 50.9951 20.4001 50.9951 25.0001Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma2);
export default __webpack_public_path__ + "static/media/figma2.cbde86e84412ea964eb4805810736b9f.svg";
export { ForwardRef as ReactComponent };